import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { FaSyncAlt } from 'react-icons/fa';
import Waves from '../Waves';
import ProductHuntFeaturedBadge from '../ProductHuntFeaturedBadge';
import styles from './index.module.scss';
import { enterAnimation, exitAnimation } from './utils';
import { useRandomJoke, usePrefersReducedMotion } from '@jokerdad/hooks';

var RandomJoke = function RandomJoke(_ref) {
  var _classnames;

  var props = _extends({}, _ref);

  var _useRandomJoke = useRandomJoke(),
      data = _useRandomJoke.data,
      error = _useRandomJoke.error,
      mutate = _useRandomJoke.mutate;

  var _useState = useState(!data),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var isReducedMotionPreferred = usePrefersReducedMotion();
  var jokeWrapperRef = useRef();
  var previousJokeRef = useRef();
  var previousJokeWrapperRef = useRef();
  var sceneClasses = classnames(styles.scene, props.className);
  var iconClasses = classnames(styles.icon, (_classnames = {}, _classnames[styles.iconAnimation] = isLoading && !isReducedMotionPreferred, _classnames));
  useEffect(function () {
    setIsLoading(!data);
  }, [data]);
  if (error) return /*#__PURE__*/React.createElement("p", null, "Failed to load!");

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var previousJoke;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              previousJoke = data;
              setIsLoading(true);
              _context.next = 4;
              return mutate();

            case 4:
              setIsLoading(false);
              previousJokeRef.current.textContent = previousJoke;

              if (!isReducedMotionPreferred) {
                enterAnimation(jokeWrapperRef);
                exitAnimation(previousJokeWrapperRef);
              } else {
                jokeWrapperRef.current.style.opacity = 1;
                previousJokeWrapperRef.current.style.opacity = 0;
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", {
    className: sceneClasses
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("span", {
    ref: previousJokeWrapperRef,
    className: styles.textWrapper
  }, /*#__PURE__*/React.createElement("span", {
    ref: previousJokeRef
  })), /*#__PURE__*/React.createElement("span", {
    ref: jokeWrapperRef,
    className: styles.textWrapper
  }, /*#__PURE__*/React.createElement("span", null, data !== null && data !== void 0 ? data : ''))), /*#__PURE__*/React.createElement(FaSyncAlt, {
    className: iconClasses,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement(Waves, {
    className: styles.waves
  }), /*#__PURE__*/React.createElement(ProductHuntFeaturedBadge, null));
};

export default RandomJoke;